import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { verifySession } from "src/store/slices/user.slice";
import Cookies from "universal-cookie";
import MfaComponent from "../components/mfa/mfa.component";
import ModalComponent from "../components/modal/modal.component";
import { IdleModal } from "./idle-modal";

const IdleTimeOutHandler = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [countdown, setCountdown] = useState(300); // Default to 5 minutes
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();

  let timer: any;
  const events = ["click", "load", "keydown", "mousemove"];
  const navigate = useNavigate();
  const isLogoutRef = useRef(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState<boolean>(false);
  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const hasShownModal = useRef(false); // Ref to track if modals have been shown

  const onSubmitMfaOtp = async () => {
    isLogoutRef.current = false;
    // setToken(localStorage.getItem("temp-token"));
    localStorage.setItem("isLogout", JSON.stringify(false));
    localStorage.removeItem("serverSignedOut");
    addEvents();
    setIsOTPModalOpen(false);
    window.location.reload();
    navigate(pathname);
  };

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const signOutTheUser = (type: "session" | "idle") => {
    return new Promise((resolve) => {
      removeEvents();
      clearTimeout(timer);
      isLogoutRef.current = true;

      localStorage.setItem("signOutFromIdleSession", JSON.stringify(true));

      if (type === "session") {
        localStorage.setItem("sessionTimeout", JSON.stringify(true));
      } else {
        localStorage.setItem("sessionTimeout", JSON.stringify(false));
      }

      return resolve(true);
    });
  };

  const eventHandler = () => {
    if (!isLogoutRef.current) {
      localStorage.setItem("lastInteractionTime", moment());
      if (timer) {
        props.onActive();
        startTimer();
      }
    }
  };

  useEffect(() => {
    addEvents();

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  }, []);

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }

    const itoInMilliseconds =
      Number.parseFloat(
        JSON.parse(localStorage.getItem("hdbUserInfo") || "{}")?.ito || "0"
      ) * 1000;

    let adjustedItoInMilliseconds: any;
    if (itoInMilliseconds) {
      adjustedItoInMilliseconds = itoInMilliseconds - 0;
    }

    timer = setTimeout(
      async () => {
        let lastInteractionTime = localStorage.getItem("lastInteractionTime");
        const diff = moment.duration(
          moment().diff(moment(lastInteractionTime))
        );

        let timeOutInterval = props.timeOutInterval
          ? props.timeOutInterval
          : adjustedItoInMilliseconds || 150000;

        if (
          localStorage.getItem("isLogout") &&
          localStorage.getItem("isLogout") === "true"
        ) {
          clearTimeout(timer);
        } else if (diff._milliseconds < timeOutInterval) {
          startTimer();
          props.onActive();
        } else if (!pathname.includes("/login")) {
          // await signOutTheUser("idle");
          // const currentUrl = window.location.href;
          localStorage.setItem("postLoginRedirect", pathname);

          setShowModal(true);
          setShowSessionModal(false);
        }
      },

      props.timeOutInterval
        ? props.timeOutInterval
        : adjustedItoInMilliseconds || 150000
    ) as unknown as number;

    let timers: number[] = JSON.parse(localStorage.getItem("timers") || "[]");
    timers.push(timer);
    localStorage.setItem("timers", JSON.stringify(timers));
  };

  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });
    startTimer();
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  useEffect(() => {
    const runSessionVerification = async () => {
      if (
        pathname === "/login" ||
        pathname === "/verify-master-data" ||
        pathname === "/login-error"
      ) {
        return;
      }

      try {
        const res: any = await dispatch(verifySession());

        // Wait for Redux to update state before continuing
        // await new Promise((resolve) => setTimeout(resolve, 5000));
        // debugger;
        if (!res?.payload?.exp) {
          handleLogout();
          return;
        }

        const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
        const timeUntilExpiry = (res?.payload?.exp - currentTime) * 1000; // Convert to milliseconds
        const showModalTime = timeUntilExpiry - 300000; // subtract 5 minutes (300000 ms)

        // Set the countdown based on the remaining time
        if (showModalTime > 0) {
          const remainingTime = Math.floor(showModalTime / 1000);
          setCountdown(remainingTime); // Set countdown to the remaining time

          const timer = setTimeout(async () => {
            await signOutTheUser("session");
            setShowModal(false);
            setShowSessionModal(true);
            setCountdown(300); // Reset countdown to 5 minutes
          }, showModalTime) as unknown as number;

          let timers: number[] = JSON.parse(
            localStorage.getItem("timers") || "[]"
          );

          timers.push(timer);
          localStorage.setItem("timers", JSON.stringify(timers));

          return () => clearTimeout(timer);
        } else if (timeUntilExpiry <= 0) {
          handleLogout();
        }
      } catch (err: any) {
        console.error("verifySession failed", err);
        handleLogout();
      }
    };

    void runSessionVerification();
  }, []);

  const handleLogout = () => {
    // Clear cookies, localStorage, and timeouts
    const cookies = new Cookies();
    cookies.remove("hdb-token");

    localStorage.clear();
    isLogoutRef.current = true;

    let timers: number[] = JSON.parse(localStorage.getItem("timers") || "[]");
    for (const id of timers) {
      clearTimeout(id);
    }

    localStorage.removeItem("timers");

    if (pathname !== "/verify-master-data" && pathname !== "/login-error") {
      navigate("/login");
    }
  };

  // Countdown effect
  useEffect(() => {
    let countdownTimer: any;

    if (showSessionModal && countdown > 0) {
      countdownTimer = setInterval(() => {
        setCountdown((prev) => {
          const newCount = prev - 1;
          localStorage.setItem("lastSessionCount", newCount.toString()); // Store updated countdown
          return newCount;
        });
      }, 1000);
    } else if (countdown === 0) {
      handleLogout();
    }
    return () => clearInterval(countdownTimer);
  }, [showSessionModal, countdown]);

  // Initialize countdown from localStorage on mount
  useEffect(() => {
    const lastSessionCount = Number.parseInt(
      localStorage.getItem("lastSessionCount") || "300",
      10
    );

    if (lastSessionCount > 0) {
      setCountdown(lastSessionCount); // Set countdown from last session count
    } else {
      handleLogout(); // If no valid countdown, redirect to login
    }
  }, []);

  // Modal display on reload
  useEffect(() => {
    if (
      localStorage.getItem("signOutFromIdleSession") === "true" &&
      pathname !== "/login" &&
      pathname !== "/verify-master-data" &&
      pathname !== "/login-error"
    ) {
      const sessionTimeout = localStorage.getItem("sessionTimeout");
      if (sessionTimeout === "false" && !showModal && !hasShownModal.current) {
        setShowModal(true);
        hasShownModal.current = true;

        // const currentUrl = window.location.href;
        localStorage.setItem("postLoginRedirect", pathname);
      } else if (
        sessionTimeout === "true" &&
        !showSessionModal &&
        !hasShownModal.current
      ) {
        setShowSessionModal(true);
        hasShownModal.current = true;

        // const currentUrl = window.location.href;
        localStorage.setItem("postLoginRedirect", pathname);
      }
    }
  }, [pathname, showModal, showSessionModal]);

  const formatTime = (seconds: number) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <div>
      <IdleModal
        showModal={
          showModal &&
          !pathname.includes("/login") &&
          !pathname.includes("/verify-master-data") &&
          !pathname.includes("/login-error")
        }
        setShowModal={setShowModal}
        type="idle"
        content={{
          title: "Idle Timeout Alert",
          body: 'You have exceeded the inactivity time limit. If you wish to continue with the session, please click "OK"',
        }}
      />
      <IdleModal
        showModal={
          showSessionModal &&
          countdown >= 0 &&
          countdown < 301 &&
          !pathname.includes("/login") &&
          !pathname.includes("/verify-master-data") &&
          !pathname.includes("/login-error")
        }
        setShowModal={setShowSessionModal}
        type="session"
        content={{
          title: "Session Timeout Alert",
          body: `You have ${formatTime(
            countdown
          )} left for this session. Would you like to re-login to continue?`,
        }}
      />
      {isOTPModalOpen && (
        <ModalComponent
          showModal={isOTPModalOpen}
          actionConfig={mfaActionConfig}
          headerTitle={"Multi Factor Authentication"}
          isViewMode={true}
          backdropClassName="custom-backdrop"
          isClosable={false}
        >
          <MfaComponent />
        </ModalComponent>
      )}
    </div>
  );
};

export default IdleTimeOutHandler;
